// extracted by mini-css-extract-plugin
module.exports = {"hidden":"logo_hidden__htB8b","logo":"logo_logo__dTJ8_"};